import './form.scss'

/* Bootstrap */
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import React, { useId } from 'react'

/* Components */
import Input from './Input'

/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

export interface input {
  placeholder: string
  type?: string
  minLength?: number
  autoComplete?: string
  required?: boolean

  preAddon?: string | React.ReactNode
  sufAddon?: string | React.ReactNode
  hilfe?: string | React.ReactNode
}

export interface tInput<keys> extends input {
  name: keys
}

/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

interface FormSubmitButtonProps {
  button: {
    text: string
  }
}

export const FormSubmitButton: React.FC<FormSubmitButtonProps> = ({ button }) =>
  <Button variant='success' type='submit'>
    {button.text}
  </Button>

/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

export interface FormProps<form, keys> {
  initialState: any
  inputs: tInput<keys>[]
  allRequired?: true
  button?: {
    text: string
  }
  modal?: {
    title: string
    show: boolean
    onHide: () => void
  }
  onSubmit?: (values: form) => void
  onChange?: (name:string, value:string) => void
}

const GetForm = <form,keys extends string>({
  initialState,
  inputs,
  onSubmit: onSubmitProp,
  onChange: onChangeProp,
  allRequired,
  button,
  modal,
}:FormProps<form,keys>) => {

  const id = useId()
  
  /* -------------------------------------------------------------------------- */

  const onChange = (name:string, value:string) => {
    if (!onChangeProp) return
    const values: Record<string, string> = {}
    const form = document.getElementById(id) as HTMLFormElement
    inputs.forEach(({ name }) => {
      values[name] = form[name]?.value
    })
    onChangeProp(name,value)
  }

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!onSubmitProp) return
    const values: Record<string, string> = {}
    const form = document.getElementById(id) as HTMLFormElement
    inputs.forEach(({ name }) => {
      values[name] = form[name]?.value
    })
    onSubmitProp(values as form)
  }
  
  const FormContent: React.FC = () => <>
    {inputs.map(({
      name,
      type='text',
      autoComplete='off',
      required,
      ...rest
    }) => {

      required = allRequired || required
      const defaultValue = initialState[name]

      const props = {
        key: name,
        ...{
          name,
          type,
          autoComplete,
          required,
          defaultValue,

          onChange,          
        },
        ...rest
      }

      return <Input {...props} />

    })}
  </>

  /* -------------------------------------------------------------------------- */

  if (!modal) {

    const MyForm: React.FC = () =>
      <Form 
        {...{id, onSubmit}} 
        className='Component-Form'
      >
        <FormContent />
  
        { button && <FormSubmitButton {...{button}} /> }
  
      </Form>
  
    return MyForm

  /* -------------------------------------------------------------------------- */

  } else {

    const { title, show, onHide } = modal

    const MyModal: React.FC = () => 
      <Modal {...{show, onHide}} className='Component-ModalForm'>
        <Form 
          {...{id, onSubmit}}
        >

          <Modal.Header>{title}</Modal.Header>

          <Modal.Body>
            <FormContent />
          </Modal.Body>

          <Modal.Footer className='Mixin-Footer-Buttons'>

            <Button variant='secondary' onClick={onHide}>
              Abbrechen
            </Button>

            { button && <FormSubmitButton {...{button}} /> }
            
          </Modal.Footer>

        </Form>
      </Modal>

    return MyModal

  }

  /* -------------------------------------------------------------------------- */

}

export default GetForm

/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */